import filterAttached from "./filterAttached";
import filterWeight from "./filterWeight";

export default function(topology, minWeight, weight) {
  var a = filterAttached(topology),
      w = filterWeight(topology, minWeight, weight);
  return function(ring, interior) {
    return a(ring, interior) || w(ring, interior);
  };
}



//////////////////
// WEBPACK FOOTER
// /Users/chrisessig/Documents/tribune/github/redistricting-CD27/node_modules/topojson/node_modules/topojson-simplify/src/filterAttachedWeight.js
// module id = null
// module chunks = 